//import axios from "axios";
//import configs from "../../../configurations/configs"

//const IP = configs.SERVER_IP;

const state = {};

const getters = {};

const actions = {
  // async authenticateAccount({commit}){
  //     await axios.get(IP + "/login").then(response => {
  //         console.log(response);
  //         commit('setAuthResponse',response)
  //     }).catch(error => {
  //         console.log(error);
  //     });
  // },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
